import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ── Service Worker Purge ──────────────────────────────────────────────
// Unregister any cached service workers to prevent stale "Coming Soon"
// or old build states from persisting on the client.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((sw) => {
      sw.unregister();
      console.info("[Argus] Service worker unregistered:", sw.scope);
    });
  });
  // Also clear any caches that might hold old responses
  if ("caches" in window) {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
        console.info("[Argus] Cache purged:", name);
      });
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
